// This is a Mixin that extends the base functionality
// of MpNews Controller, for public news page (not registered users)
var MpOtmService = {
    created: function () {
    },
    data: function() {
        return {
            FORM_URL: '/services/oiltimemarket/',

            ACTION_SELL: 'Vender',
            ACTION_BUY: 'Comprar',
            PUBLIC_OK: 'Sí',
            PUBLIC_KO: 'No',

            name: '',
            nif: '',
            email: '',
            phone: '',
            action: [],
            public: '',
            privacity: false,

            errors: [],
            successMessage: '',
            validated: false,

            isLegalShown: false,
            isInitialized: false,
        };
    },
    computed: {

        nameCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.name);
        },
        nifCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.nif);
        },
        emailCheck: function() {
            return !this.validated || FormValidator.isValidEmail(this.email);
        },
        phoneCheck: function() {
            return !this.validated || FormValidator.isNumber(this.phone);
        },
        privacityCheck: function() {
            return (!this.validated || this.privacity);
        },
        dataForm: function() {
            return Serializer.serialize({
                'name': this.name,
                'nif': this.nif,
                'email': this.email,
                'phone': this.phone,
                'action': this.action,
                'public': this.public,
                'privacity': this.privacity,
            });
        },

        isSellActive: function() {
            return this.action.indexOf(this.ACTION_SELL) >= 0;
        }
    },
    methods: {

        closeLegalModal: function() {
            noScroll.off();
            this.isLegalShown = false;
        },

        showLegalConditions: function(ev) {
            if (ev.target.tagName === 'A') {
                ev.preventDefault();
                noScroll.on();
                this.isLegalShown = true;
            }
        },

        cleanErrors: function() {
            this.errors = [];
        },

        addError: function(errorMsg) {
            if (this.errors.length > 0) {
                return;
            }

            this.errors.push(errorMsg);
        },

        validateForm: function() {
            /// error_data, data_ko & error_privacity
            /// are globally injected from PHP controller
            var isValid = true;

            this.cleanErrors();
            this.successMessage = '';
            this.validated = true;

            if (!this.nameCheck) {
                this.addError(error_data);
                isValid = false;
            }

            if (!this.nifCheck) {
                isValid = false;
                this.addError(error_data);
            }

            if (!this.emailCheck) {
                isValid = false;
                this.addError(data_ko);
            }

            if (!this.phoneCheck) {
                isValid = false;
                this.addError(error_data);
            }

            if (!this.privacityCheck) {
                isValid = false;
                this.addError(error_privacity);
            }

            return isValid;
        },

        resetForm: function() {
            this.name = '';
            this.nif = '';
            this.email = '';
            this.phone = '';
            this.privacity = false;

            this.validated = false;
            this.cleanErrors();
        },

        onFormSent: function(response) {
            if (response.data.result === 'OK') {
                this.successMessage = response.data.message;
            } else {
                this.addError(response.data.message);
            }
        },

        sendForm: function() {
            if (this.validateForm()) {
                axios
                    .post(this.FORM_URL, this.dataForm)
                    .then(this.onFormSent)
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.isInitialized = true;
        },

    },

    mounted: function() {
        this.name = (this.$refs.name) ? this.$refs.name.getAttribute('data-init') : '';
        this.nif = (this.$refs.nif) ? this.$refs.nif.getAttribute('data-init') : '';
        this.email = (this.$refs.email) ? this.$refs.email.getAttribute('data-init') : '';
        this.phone = (this.$refs.phone) ? this.$refs.phone.getAttribute('data-init') : '';
        this.public = this.PUBLIC_OK;

        this.init();
    }
};
